import React, { useEffect, useState } from "react";
import {
  banner, banner2, banner3, banner4, banner5,  gallery1, gallery2,gallery3,gallery4
} from "../../Assets.tsx";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Gallery = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useGSAP(() => {
    if (!isMobile) {
    gsap.from(".ourGallery", {
        opacity: 0,
        duration: 2,
        x: 500,
        scrollTrigger: {
          trigger: ".ourGallery",
          scroller: "body",
          markers: false,
          start: "top 50%",
        },
      });
    }
  });
  const galleryImages = [banner, banner2, banner3, banner4, banner5, gallery1, gallery2,gallery3,gallery4];

  return (
    <div id="Gallery">
      <div className=" ourGallery GallerySectionMarginTitle" style={{textAlign:"center",margin:"45px 0 0 0", fontSize: "50px", fontWeight: 500}}>Gallery</div>

      <div
      className="GallerySectionMargin"
        style={{
          margin: "20px 50px 40px 50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        {galleryImages.map((image, index) => (
          <img
            key={index}
            src={image}
            className="car-card"
            alt={`gallery-img-${index}`}
            style={{ width: "350px", margin: "2px 5px",borderRadius: "5px" }}
          />
        ))}
      </div>
    </div>
  );
};

export default Gallery;
